import {ContextStore} from "../../../../../../react-core/Flux/Variables";
import {AccountStatus} from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import {ClientAccount} from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import {ProcessType} from "../../../../../Shared/IST/Resource/Content";

/**
 * check if need to block the wizard entry point with a popup message
 *
 * Top-up - Head Account status must = Active [Single Payment / Transfer,Add Regular Payment,Edit Regular Payment]
 * Buy - Cannot access where SubAccount status = Closing or Closed
 * Sell - Cannot access where SubAccount status = Closed. Internal users only can access where SubAccount status = Closing
 * Switch - Cannot access where SubAccount status = Closing or Closed
 * Withdrawal - Cannot access where SubAccount status = Closing or Closed. Internal users only can access where SubAccount status = Closing
 * 'What If' & 'No change' - Cannot access where SubAccount status = Closing or Closed
 *
 * @returns boolean => True for need block
 * story: SLP-92757
 */

export const WizardLinkRestriction = (
    headAccount: ClientAccount,
    subAccountHierarchyId: string,
    processType: ProcessType
): boolean => {
    if (
        [ProcessType.AddRegular, ProcessType.EditRegular, ProcessType.SinglePayment, ProcessType.TakePensionBenefits, ProcessType.TopUpWithITFLS].includes(processType) &&
        headAccount?.AccountStatus != AccountStatus.Active
    ) {
        return true;
    }
    const subAccountStatus = (headAccount?.SubAccounts || []).find(
        (account) => account.HierarchyId == subAccountHierarchyId
    )?.Status;
    if (
        [
            ProcessType.NoChange,
            ProcessType.WhatIf,
            ProcessType.Buy,
            ProcessType.Switch,
            ProcessType.MoveAssetsToNewOwner,
            ProcessType.NBEC
        ].includes(processType) &&
        [AccountStatus.Closed, AccountStatus.Closing].includes(subAccountStatus)
    ) {
        return true;
    }
    if (
        [ProcessType.Sell].includes(processType) &&
        [AccountStatus.Closed].includes(subAccountStatus)
    ) {
        return true;
    }
    if (
        [ProcessType.Sell, ProcessType.Withdrawal].includes(processType) &&
        [AccountStatus.Closing].includes(subAccountStatus) &&
        !ContextStore.getContext().isAdminUser
    ) {
        return true;
    }
    return false;
};
